module.exports = __webpack_public_path__ + "img/13.ffbd0a9f.png";